/* eslint-disable no-unused-expressions */
import COLORS from '@lib/constants/colors';
import { useRef, useState } from 'react';
import styled from 'styled-components';

const Form = styled.form`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  /* Change width of the form depending if the bar is opened or not */
  max-width: 400px;
  width: 100%;

  padding: 12px;
  border-radius: 8px;
  transition: width 300ms cubic-bezier(0.645, 0.045, 0.355, 1);
`;

const Input = styled.input`
  font-size: 14px;
  line-height: 1;
  background-color: transparent;
  width: 100%;
  margin-left: 0;
  border: none;
  color: ${COLORS.black};
  transition: margin 300ms cubic-bezier(0.645, 0.045, 0.355, 1);

  &:focus,
  &:active {
    outline: none;
  }
  &::placeholder {
  }
`;

const Button = styled.button`
  line-height: 1;
  background-color: transparent;
  border: none;
  outline: none;
  color: ${COLORS.black};

  svg {
    height: 24px;
    width: 24px;
    fill: #c4c4c4;
  }
`;

const SearchForm = ({
  onSearch,
  defaultValue,
  placeholder = 'Buscar...',
}: {
  onSearch: (searchTerm: string) => void;
  defaultValue?: string;
  placeholder?: string;
}) => {
  const [input, setInput] = useState(defaultValue || '');

  const formRef = useRef<HTMLFormElement>(null);

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();

        onSearch(input);
      }}
      ref={formRef}
    >
      <Input
        onChange={(e) => setInput(e.target.value)}
        value={input}
        required
        placeholder={placeholder}
        // type="search"
        name="q"
      />
      <Button type="submit">
        <svg
          id="icon-magnifying-glass"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 793.9 792"
        >
          <path d="M787.5 707.2L562 481.6c33.5-49 53.2-108.3 53.2-172.1C615.2 141.1 478.1 4 309.6 4S4 141.1 4 309.6s137.1 305.6 305.6 305.6c63.5 0 122.6-19.5 171.5-52.8L706.7 788l80.8-80.8zM118.3 309.6c0-105.5 85.8-191.3 191.3-191.3s191.3 85.8 191.3 191.3S415 500.8 309.6 500.8 118.3 415 118.3 309.6z" />
          <path d="M309.6 615.2C141.1 615.2 4 478.1 4 309.6S141.1 4 309.6 4s305.6 137.1 305.6 305.6-137.1 305.6-305.6 305.6zm0-496.9c-105.5 0-191.3 85.8-191.3 191.3s85.8 191.3 191.3 191.3S500.8 415 500.8 309.6 415 118.3 309.6 118.3z" />
          <path d="M439.954 521.248l80.821-80.822 266.719 266.718-80.822 80.822z" />
          <path
            className="st2-mg"
            d="M480.9 562.5l-41.1-41.1 80.8-80.8 41.2 41.2c-36.9 54-80.9 80.7-80.9 80.7z"
          />
        </svg>
      </Button>
    </Form>
  );
};

export default SearchForm;
